import quantityId from '../enums/quantityId.js';
import Quantity from '../entities/quantity.js';
import Unit from '../entities/unit.js';

const length = new Quantity(
    quantityId.LENGTH,
    'Length'
);

length.registerUnit(
    new Unit(
        'm', 1, 'metre', [
            "m"
        ]
    )
);

length.registerUnit(
    new Unit(
        'cm', 100, 'centimetre', [
            "cm"
        ]
    )
);

length.registerUnit(
    new Unit(
        'km', 0.001, 'kilometre', [
            "km"
        ]
    )
);

length.registerUnit(
    new Unit(
        'yd', 1 / 0.9144, 'yard', [
            "yds", "yd"
        ]
    )
);

length.registerUnit(
    new Unit(
        'ft', 3 / 0.9144, 'foot', [
            "ft", "′", "'"
        ]
    )
);

length.registerUnit(
    new Unit(
        'in', (3 * 12) / 0.9144, 'inch', [
            "in", "″", "\""
        ]
    )
);

length.registerUnit(
    new Unit(
        'mi', 0.00062137119223733, 'land mile', [
            "mi"
        ]
    )
);

length.registerUnit(
    new Unit(
        'ftin', 3 / 0.9144, 'Foot & inch (ft in)', [
            "ftin"
        ]
    )
);
export default length;